import React, { useEffect, useState } from 'react';
import { Page } from 'src/containers';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ButtonCard, Button } from 'src/components';

import { Div, Icon, Row, Col } from '@pinpoint/design-kit';

import { ROUTES } from 'src/config';
import CONSTANTS from 'src/store/constants';

function GenerateModels() {
  const [classifierEnabled, setClassifierEnabled] = useState(true);
  const [actuarialEnabled, setActuarialEnabled] = useState(true);
  const history = useHistory();
  const client = useSelector(({ app: { client: _client } }) => _client);
  const goToClassifier = () => {
    history.push(ROUTES.NEW_ONBOARDING, { model: CONSTANTS.ONBOARDING_MODELS.CLASSIFIER_MODEL });
  };
  const goToActuarial = () => {
    history.push(ROUTES.NEW_ONBOARDING, { model: CONSTANTS.ONBOARDING_MODELS.ACTUARIAL_MODEL });
  };

  useEffect(() => {
    if (client) {
      setClassifierEnabled(client.canModel);
      setActuarialEnabled(client.canModel);
    }
  }, [client]);

  return (
    <Div d="flex" p={{ t: '4.5rem', l: '8.875rem' }} flexDir="column">
      <Row m="0">
        <Col gutterWidth="0">
          <Button
            buttonStyle="primary"
            m={{ r: '1rem' }}
            onClick={() => {
              history.push(ROUTES.ONBOARDING_LANDING);
            }}
            data-tip="go back"
          >
            <Icon color="white" name="LongLeft" m={{ r: '0.5rem' }} size="1rem" />
            BACK
          </Button>
        </Col>
        <Col gutterWidth="0">
          <Button
            h="1.875rem"
            m={{ l: '1rem' }}
            p={{ x: '0.75rem' }}
            hoverBg="brand500"
            bg="brand500"
            style={{ cursor: 'default' }}
          >
            <Icon color="white" name="AI" m={{ r: '0.5rem' }} size="1.125rem" viewBox="0 0 51 60" />
            GENERATE MODEL
          </Button>
        </Col>
      </Row>
      <Row m="0">
        <Col gutterWidth="0" border={{ r: '1px solid' }} w="8.375rem" borderColor="shadeAF" h="2rem" />
        <Col gutterWidth="0" w="22rem">
          <Row m="0" h="100%">
            <Col gutterWidth="0" border={{ b: '1px solid' }} w="100%" h="50%" borderColor="shadeAF" />
            <Col gutterWidth="0" border={{ r: '1px solid' }} w="100%" h="50%" borderColor="shadeAF" />
          </Row>
        </Col>
      </Row>
      <Row m="0">
        <Col gutterWidth="0">
          <ButtonCard
            m="0"
            iconName="ActuarialModel"
            iconViewBox="0 0 12 10"
            iconSize="3.75rem"
            name="Actuarial Models"
            description="Generate actuarial-loss models"
            hoverTopBg="navyBlue"
            bottomBg="navyBlue"
            hoverBottomBg="navyBlueDark"
            disabled={!actuarialEnabled}
            onClick={goToActuarial}
          />
        </Col>
        <Col gutterWidth="0">
          <ButtonCard
            m={{ y: '0', l: '2.5rem' }}
            iconName="ClassifierModel"
            iconViewBox="0 0 10 16"
            iconSize="3.75rem"
            name="Classifier Models"
            description="Generate binary-classifier models"
            hoverTopBg="navyBlue"
            bottomBg="navyBlue"
            hoverBottomBg="navyBlueDark"
            disabled={!classifierEnabled}
            onClick={goToClassifier}
          />
        </Col>
      </Row>
    </Div>
  );
}

export default Page(GenerateModels);
